module.exports = __webpack_public_path__ + "img/Puentes.fb078aae.svg";